import { render, staticRenderFns } from "./DefaultHeader.vue?vue&type=template&id=146e5c56&scoped=true&"
import script from "./DefaultHeader.vue?vue&type=script&lang=js&"
export * from "./DefaultHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "146e5c56",
  null
  
)

export default component.exports